import type { FeatureGeometriesMachine } from '@/features/execute-calculation-set/overmind/arcgis/featureGeometries';

import type { PowerTransformer } from '../../grid/FunctionalGrid';

export function getFeedingTransformerName(
  powerTransformer: PowerTransformer | undefined,
  featureGeometries: FeatureGeometriesMachine
):
  | { type: 'TRANSFORMER_NAME'; name: string }
  | { type: 'TRANSFORMER_NAME_NOT_FOUND' } {
  if (!powerTransformer) return { type: 'TRANSFORMER_NAME_NOT_FOUND' };
  if (featureGeometries.current !== 'LOADED')
    return { type: 'TRANSFORMER_NAME_NOT_FOUND' };

  const allFeatures = featureGeometries.value.flatMap(layer => layer.features);

  const transformerAsFeature = allFeatures.find(
    feature => feature.gc.globalId === powerTransformer.objectId
  );

  if (!transformerAsFeature) return { type: 'TRANSFORMER_NAME_NOT_FOUND' };
  const transformerName = transformerAsFeature.gc.title;
  if (!transformerName) return { type: 'TRANSFORMER_NAME_NOT_FOUND' };

  return { type: 'TRANSFORMER_NAME', name: transformerName };
}
